export default __webpack_public_path__ + "static/media/paul-dezeeuw.a7efe39a.jpg";